import { Injectable } from "@angular/core";
import { IdName } from "@shared/models/id-name";

@Injectable()
export class CompareOptionsService {

	static compare(option1: IdName, option2: IdName) {
		return option1?.Id === option2?.Id;
	}
}